import {Fragment} from 'react';
import {ZONA_DE_CARGA_URL} from '@/lib/official-terms';

/**
 * Convierte en enlaces las URLs, los correos y las menciones a las "Reglas de
 * Zona de Carga" que aparecen dentro de un texto, sin alterar ni una letra del
 * texto original — importante porque las cláusulas son texto legal literal.
 */
const PATTERN = /(https?:\/\/[^\s<>"]+)|([A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z0-9.-]+)|(Reglas de Zona de Carga)/g;

/** La puntuación final de la oración no forma parte de la URL ni del correo. */
function splitTrailingPunctuation(token: string): [string, string] {
  const match = token.match(/[.,;:)\]]+$/);
  if (!match) return [token, ''];
  return [token.slice(0, -match[0].length), match[0]];
}

const linkStyles =
  'text-amber underline underline-offset-2 decoration-amber/40 transition-colors hover:text-tangerine hover:decoration-tangerine focus-visible:outline-2 focus-visible:outline-offset-2 break-words';

export function LinkedText({text}: {text: string}) {
  const parts: React.ReactNode[] = [];
  let cursor = 0;

  for (const match of text.matchAll(PATTERN)) {
    const [token, url, , zonaDeCarga] = match;
    const start = match.index;

    if (start > cursor) parts.push(text.slice(cursor, start));
    cursor = start + token.length;

    if (zonaDeCarga) {
      parts.push(
        <a key={start} href={ZONA_DE_CARGA_URL} target="_blank" rel="noreferrer" className={linkStyles}>
          {zonaDeCarga}
        </a>,
      );
      continue;
    }

    const [clean, trailing] = splitTrailingPunctuation(token);
    const href = url ? clean : `mailto:${clean}`;
    parts.push(
      <Fragment key={start}>
        <a href={href} {...(url ? {target: '_blank', rel: 'noreferrer'} : {})} className={linkStyles}>
          {clean}
        </a>
        {trailing}
      </Fragment>,
    );
  }

  if (cursor < text.length) parts.push(text.slice(cursor));

  return <>{parts}</>;
}
